(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resilia-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', function(event) {
  initSlider();
});

document.addEventListener('DOMContentLoaded', function() {
  initSlider();
});

function initSlider() {
  const container = document.querySelector('.testimonial-container');
  if (!container) return;

  const dots = document.querySelectorAll('.dot');
  const prevBtn = document.querySelector('.btn-prev');
  const nextBtn = document.querySelector('.btn-next');

  if(container) {
    container.addEventListener('scroll', () => {
      const index = Math.round(container.scrollLeft / container.clientWidth);
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    });
  }

  if(prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      container.scrollBy({ left: -container.clientWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      container.scrollBy({ left: container.clientWidth, behavior: 'smooth' });
    });
  }
}

  } catch(e) { console.error(e); }
})();
})();
